import { FC, SVGProps } from 'react';

export const LastInListIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 24.2784C6 23.5744 6.58398 23.0038 7.30435 23.0038H8.17391C8.89428 23.0038 9.47826 23.5744 9.47826 24.2784C9.47826 24.9823 8.89428 25.5529 8.17391 25.5529H7.30435C6.58398 25.5529 6 24.9823 6 24.2784ZM12.087 24.2784C12.087 23.5744 12.6709 23.0038 13.3913 23.0038H24.6956C25.416 23.0038 26 23.5744 26 24.2784C26 24.9823 25.416 25.5529 24.6956 25.5529H13.3913C12.6709 25.5529 12.087 24.9823 12.087 24.2784Z"
			fill="currentColor"
		/>
		<path
			d="M6 6.87454C6 6.17062 6.58398 5.59998 7.30435 5.59998H8.17391C8.89428 5.59998 9.47826 6.17062 9.47826 6.87454C9.47826 7.57847 8.89428 8.14911 8.17391 8.14911H7.30435C6.58398 8.14911 6 7.57847 6 6.87454Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
		<path
			d="M12.087 6.87454C12.087 6.17062 12.6709 5.59998 13.3913 5.59998H24.6956C25.416 5.59998 26 6.17062 26 6.87454C26 7.57847 25.416 8.14911 24.6956 8.14911H13.3913C12.6709 8.14911 12.087 7.57847 12.087 6.87454Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
		<path
			d="M6 12.3824C6 11.6784 6.58398 11.1078 7.30435 11.1078H8.17391C8.89428 11.1078 9.47826 11.6784 9.47826 12.3824C9.47826 13.0863 8.89428 13.6569 8.17391 13.6569H7.30435C6.58398 13.6569 6 13.0863 6 12.3824Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
		<path
			d="M12.087 12.3824C12.087 11.6784 12.6709 11.1078 13.3913 11.1078H24.6956C25.416 11.1078 26 11.6784 26 12.3824C26 13.0863 25.416 13.6569 24.6956 13.6569H13.3913C12.6709 13.6569 12.087 13.0863 12.087 12.3824Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
		<path
			d="M6 18.3303C6 17.6264 6.58398 17.0558 7.30435 17.0558H8.17391C8.89428 17.0558 9.47826 17.6264 9.47826 18.3303C9.47826 19.0343 8.89428 19.6049 8.17391 19.6049H7.30435C6.58398 19.6049 6 19.0343 6 18.3303Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
		<path
			d="M12.087 18.3303C12.087 17.6264 12.6709 17.0558 13.3913 17.0558H24.6956C25.416 17.0558 26 17.6264 26 18.3303C26 19.0343 25.416 19.6049 24.6956 19.6049H13.3913C12.6709 19.6049 12.087 19.0343 12.087 18.3303Z"
			fill="currentColor"
			fillOpacity="0.2"
		/>
	</svg>
);
